.modal {
  max-width: 750px !important;
}
